import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from '../models/device.model';
import { GenericApiService } from './generic-api.service';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private api = inject(GenericApiService);

  getDevices(contextId?: string): Observable<{ devices: Device[] }> {
    return this.api.query<{ devices: Device[] }>('LIST_DEVICES', contextId ? { contextId } : undefined);
  }

  claimDevice(code: string, name?: string, spaceId?: string): Observable<any> {
    const payload: any = { device_id: code.trim() };
    if (name?.trim()) {
      payload.name = name.trim();
    }
    if (spaceId?.trim()) {
      payload.space_id = spaceId.trim();
    }
    return this.api.query<any>('CLAIM_DEVICE', payload);
  }

  unlinkDevice(id: string): Observable<{ success: boolean; message?: string }> {
    return this.api.query<{ success: boolean; message?: string }>('UNLINK_DEVICE', { id });
  }

  toggleDeviceStatus(id: string, status: string): Observable<{ success: boolean; message?: string }> {
    return this.api.query<{ success: boolean; message?: string }>('TOGGLE_DEVICE_STATUS', { id, status });
  }
}
